var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-824.000000, -1103.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Color",
    transform: "translate(824.000000, 1103.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9890676,0 C16.5414413,0 16.9897446,0.447 16.9897446,1 L16.9897446,1 L16.9897446,8.067 L27.9151363,18.985 L16.6495144,30.242 C14.3049282,32.586 10.5033562,32.586 8.15876992,30.242 L8.15876992,30.242 L1.75843969,23.846 C-0.586146565,21.503 -0.586146565,17.704 1.75843969,15.361 L1.75843969,15.361 L13.0230609,4.104 L13.9877136,5.067 L13.9877136,14.081 C13.6775037,14.497 13.4873751,15.008 13.4873751,15.567 C13.4873751,16.948 14.6071326,18.067 15.9890676,18.067 C17.3710026,18.067 18.4907602,16.948 18.4907602,15.567 C18.4907602,14.543 17.8723418,13.664 16.9897446,13.278 L16.9897446,13.278 L16.9897446,15.067 C16.9897446,15.619 16.5414413,16.067 15.9890676,16.067 C15.4366939,16.067 14.9883906,15.619 14.9883906,15.067 L14.9883906,15.067 L14.9883906,1 C14.9883906,0.447 15.4366939,0 15.9890676,0 Z M29.0149804,20.1139 L31.0383494,22.8079 L31.3265444,23.1959 C31.7478294,23.7099 32,24.3659 32,25.0849 C32,25.3399 31.9669777,25.5849 31.9099391,25.8209 C31.5827177,27.1129 30.4079229,28.0669 29.0149804,28.0669 C27.3668654,28.0669 26.0309616,26.7319 26.0309616,25.0849 C26.0309616,24.3849 26.2721247,23.7429 26.6743969,23.2359 L26.6743969,23.2359 L27.7551281,21.7939 L28.5136413,20.7839 L29.0149804,20.1139 Z",
    id: 154
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionColor);
export default __webpack_public_path__ + "static/media/navigation-and-action-color.3f9da65d.svg";
export { ForwardRef as ReactComponent };